import { render, staticRenderFns } from "./SalesTransactions.vue?vue&type=template&id=46da5ff0"
import script from "./SalesTransactions.vue?vue&type=script&lang=js"
export * from "./SalesTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports